export default {"src":"/_next/static/media/honesty_icon.5cbbb9dc.svg","height":55,"width":55,"blurWidth":0,"blurHeight":0};